export const SET_DATA = 'mp/customer/SET_DATA';
export * from './selectors';

export const initialState = {
  loaded: false,
  customer: {
    customer: {}
  }
};

export const customer = (state = initialState, action = {}) => {
  switch (action.type) {

    case SET_DATA:
      return {
        ...state,
        ...action.payload
      };

    default:
      return state;
  }
};

export default customer;



/** WEBPACK FOOTER **
 ** ./client/redux/modules/data/customer/customer.js
 **/